import React from "react";
import DepartmentForm from "./DepartmentForm";
import PropTypes from "prop-types";

import { IntlProvider } from "react-intl";
import {locale, translations} from "../util/i18n";

const EditDepartmentModal = (props) => {
  return (
    <IntlProvider locale={locale} key={locale} messages={translations[locale]}>
      <DepartmentForm url={props.url} method="PUT" defaultValues={props.details}/>
    </IntlProvider>
  );
};

EditDepartmentModal.propTypes = {
  url: PropTypes.string.isRequired,
  details: PropTypes.object.isRequired,
};

export default EditDepartmentModal;
